module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-835-min.f10f7969.jpg";